import styled from "styled-components";

export const BaseComp = styled.div`
    display: flex;
    padding: 3%;
    @media only screen and (max-width: 1350px) {
        padding: 5% 5%;
    }
    @media only screen and (max-width: 800px) {
        padding: 5%;
        flex-direction: column;
    }
    height: 100%;

`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const TextContent = styled.div`
    color: var(--var(--purple-bhbusmidia));
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 40%;
    justify-content: center;
    padding: 1%;
    @media only screen and (max-width: 800px) {
        width: 100%;
    }
`;

export const TextTitle = styled.div`
    h1 {
        font-size: 36px;
        color: var(--purple-dark);
    }
    text-align: left;
    h2 {
        font-weight: normal;
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    text-align: left;
    padding: 10px;
    p {
        margin-top: 3%;
    }
    @media only screen and (max-width: 800px) {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const ImageContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
    @media only screen and (max-width: 800px) {
        width: 100%;
        margin-top: 10%;
        flex-direction: column;
    }

    .image {
        width: 210px;
        height: auto;
    }

    .swiper-pagination-bullets {
        margin-top: 5%;
    }
`;

export const DefaultBox = styled.div`
    justify-content: center;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    h4 {
        color: var(--purple);
        margin: 5px 0px;
    }
`;

export const Img = styled.img`
    width: 160px;
    height: 160px;
    @media only screen and (max-width: 800px) {
        width: 180px;
        height: 180px;
    }
`;

export const ImageBox = styled.div`
    margin: 2%;
`;

export const SidebySideContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }
`;

export const ContactConsultant = styled.div`
    background-color: #F7A816;
    border-radius: 20px;
    justify-content: center;
    cursor: pointer;
    max-width: 180px;
    display: flex;
    padding: 5px 8px;
    p {
        font-size: 16px;
        font-weight: bold;
    }
    margin-top: 20px;
    align-items: center;
`;